import {nl} from './nl'

export const fr = {
	...nl,
	project_name: 'Broederlijk Delen',
	cards: {
		event: {
			linklabel: ''
		},
		page: {
			linklabel: ''
		},
		project: {
			linklabel: ''
		}
	},
	form: {
		file: {
			delete: '',
			invalid_type: '',
			too_large: ''
		},
		back: '',
		submit: ''
	},
	newsletter: {
		title: '',
		submitted: ''
	},
	search: {
		search: '',
		submit: '',
		empty: '',
		results: {
			loading: '',
			empty: ''
		}
	},
	error404: {
		title: 'Page non trouvée',
		text: `La page que vous recherchez a peut-être été supprimée, 
				son nom a été modifié ou est temporairement indisponible.`,
		btnlabel: "Retour à l'accueil"
	},
	cookies: {
		banner: {
			text:
				'Ce site internet utulise des cookies pour améliorer votre expérience de surf.',
			settings: 'Paramétrer les cookies',
			accept: 'Accepter tous les cookies',
			decline: 'Refuser cookies optionnels'
		},
		settings: {
			title: 'Paramétrer les cookies',
			text:
				'Vous pouvez accepter tous les cookies en même temps ou ajuster vos préférences dans les paramètres des cookies.',
			save: 'Sauver',
			accept: 'Accepter tous les cookies',
			decline: 'Refuser cookies optionnels'
		},
		used: 'Cookies utilisés',
		table: {
			name: 'Nom',
			purpose: 'But',
			domain: 'Domaine/hôte',
			duration: 'Durée'
		},
		duration: {
			persistent: 'Permanent',
			session: 'Session',
			day: 'jour',
			days: 'journées',
			month: 'mois',
			months: 'mois',
			year: 'année'
		}
	},
	webshop: {
		filter: {
			load_more: '',
			load_more_products: '',
			load_more_downloads: '',
			label: '',
			reset: '',
			empty: '',
			no_products: '',
			no_downloads: ''
		},
		header: {
			cart: {
				items_in_cart: '',
				empty: ''
			}
		},
		products: {
			card: {
				from: '',
				pieces: '',
				free: '',
				add: '',
				notifiy: '',
				remove: '',
				featured: '',
				last_pieces: '',
				temporarily_unavailable: '',
				sold_out: '',
				coming_soon: '',
				added: ''
			},
			notify: {
				info: '',
				newsletter: '',
				submit: '',
				submitted: ''
			},
			related: ''
		},
		cart: {
			title: '',
			from: '',
			pieces: '',
			remove: '',
			add: '',
			edit: '',
			edited: '',
			added: '',
			quantity_discount: '',
			free: '',
			empty: '',
			total: '',
			abandoned: {
				title: '',
				text: ``,
				btnclose: '',
				btnback: ''
			},
			order: ''
		}
	},
	campagne: {
		open: '',
		close: '',
		share: '',
		languages: '',
		hero: {
			help: ''
		},
		footer: {
			copyright: '',
			do_action: '',
			register_action: ''
		},
		action: {
			watch: '',
			share: '',
			watch_page: '',
			promotion_title: '',
			promotion_share: '',
			poster: '',
			need: '',
			download: '',
			order: '',
			share_online: '',
			header: '',
			shareimage: '',
			copied: ''
		},
		actions: {
			title: '',
			loadmore: '',
			no_results: '',
			clearfilters: ''
		},
		inspiration: {
			practical: ''
		},
		inspirations: {
			checkout: '',
			select: ''
		},
		info: {
			moreinfo: '',
			practical: '',
			on: '',
			from: '',
			until: '',
			at: '',
			between: '',
			and: '',
			box: '',
			not_public: '',
			public: '',
			sign_up: ''
		},
		register: {
			postal_code: '',
			school: '',
			multiple_days: '',
			end_hour: '',
			at: '',
			h: '',
			until: '',
			when: '',
			submit: '',
			textarea: '',
			textarea_placeholder: '',
			max100: '',
			organisation: '',
			location_placeholder: '',
			date_placeholder: '',
			hour_placeholder: ''
		},
		affichebuilder: {
			with: '',
			we_share: '',
			at: ''
		},
		contact: {
			name: '',
			email: '',
			question: '',
			submit: '',
			thanks: ''
		},
		filters: {
			location: '',
			keyword: '',
			periode: '',
			periode_detail: '',
			and: '',
			filtertitle: '',
			radius: ''
		},
		filterkeys: {
			food: '',
			sell: '',
			sports: '',
			culture: '',
			party: '',
			drinks: '',
			doortodoor: '',
			other: ''
		},
		error404: {
			title: '',
			text: ''
		},
		cookies: {
			text: '',
			accept: '',
			decline: ''
		}
	},
	news: {
		publishedOn: 'Publié le'
	}
}
